import { render, staticRenderFns } from "./BarCard.vue?vue&type=template&id=b07ddd38&scoped=true&"
import script from "./BarCard.vue?vue&type=script&lang=js&"
export * from "./BarCard.vue?vue&type=script&lang=js&"
import style0 from "./BarCard.vue?vue&type=style&index=0&id=b07ddd38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07ddd38",
  null
  
)

export default component.exports